module.exports = __webpack_public_path__ + "img/tile-type_cn.67afc54.jpg";